module.exports = __webpack_public_path__ + "static/bsas006-c958ba34ad242eed3873ff67e204e66c.jpg";